import { Component, Input, inject } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import { FeatureFlag } from "src/app/core/enums/feature-flag";
import { Division } from "src/app/core/interfaces/division";
import { FeatureFlagService } from "src/app/core/services/feature-flag.service";
import { INotificationSettings } from "../../../../../../../interfaces/dialogs/notification-settings";
import { Square } from "../../../square/square.component";

@Component({
  selector: "app-im-notification-settings-edit-email",
  templateUrl: "./notification-settings-edit-email.component.html",
  styleUrls: ["../../style.scss"]
})
export class IMNotificationSettingsEditEmailComponent {
  @Input() public division: Division = "electricity";
  @Input() public formGroup: FormGroup;
  @Input() public indeterminate: INotificationSettings;
  @Input() public notificationSquares: { [key: string]: Square };
  public checkboxWarning: AbstractControl;

  private readonly featureFlag = inject(FeatureFlagService);
  public readonly excavationNotificationEnabled = this.featureFlag.isEnabled(FeatureFlag.OMExcavationNotification);

  public get startEndControl(): AbstractControl | null {
    return this.formGroup.get("startEnd");
  }

  public validateCheckboxes(control?: AbstractControl): void {
    if (!control || control.value) {
      this.checkboxWarning = undefined;
      return;
    }

    if (control.disabled) {
      return;
    }

    this.checkboxWarning = control;
  }
}
